import { Moment } from "moment";
import {
  IQACustomDetails,
  JobEstimationDetail,
} from "./modals/JobEstimationDetail";
import { IBodyshopService } from "./UserService";
import { BookingAllowance } from "./modals/BookingAllowance";

export interface jobSheetProfile {
  id: string;
  name: string;
  version: string;
}

export interface EstimateDetails {
  header: Header;
  primaryDetail: PrimaryDetail;
  excessDetail?: null;
  totals: Totals;
  debtorProfile: DebtorProfile;
  productionSummary?: ProductionSummary[];
}
export interface ProductionSummary {
  id: string;
  grossProfit: number;
  needed: number;
  ordered: number;
  arrived: number;
  backordered: number;
  activities: Activity[];
}
export enum WorkType {
  SMALL = "1. Small",
  MEDIUM = "2. Medium",
  LARGE = "3. Large",
}

export enum ActionType {
  AcceptedEstimate = "acceptedEstimate",
  EstimateFirstTimeLogin = "estimateFirstTimeLogin",
  DirectBookingInspectionCheck = "directBookingInspectionCheck"
}

export enum AdminChecklist {
  BookingFlow = "6. Booking Flow",
}


export interface Activity {
  id: string;
  activityName: string;
  sequence: number;
  status: string;
  users: User[];
  hasLabourRecords: boolean;
}

export interface User {
  id: string;
  userName: string;
  email?:string | null;
  phone?:string | null;
  lastStarted: string;
}
export interface Header {
  assessingProviderId?: null;
  arrivalNote: string;
  baseTaxRate: number;
  canCancelEstimate: boolean;
  clientContributionAmount: number;
  clientContributionReason?: null;
  created: string;
  driver: Driver;
  estimateDueDate?: null;
  estimateNumber: number;
  estimatorId: string;
  estimatorName: string;
  excessAmount: number;
  excessDebtor: ExcessDebtorOrPrimaryDebtor;
  excessDetailId?: null;
  excessNotApplicable: boolean;
  hasInsurerClaim: boolean;
  hasLoanCar: boolean;
  hasOwnerWork: boolean;
  id: string;
  includeOwnerDetailsInJobSheet: boolean;
  insurerClaimNumber: string;
  insurerPolicyNumber?: null;
  isCancelled: boolean;
  isClosed: boolean;
  isEstimateWritten: boolean;
  isLegacy: boolean;
  isVehicleOnSite: boolean;
  jobBooking: JobBooking;
  jobNumber: number;
  vehicleLocation?: null;
  notes?: NotesEntity[] | null;
  owner: Owner;
  ownerOrderNumber?: null;
  primaryDebtor: ExcessDebtorOrPrimaryDebtor;
  primaryDetailId: string;
  quotationRequestDate: string;
  quotationRequestId: string;
  requestVersionNumber: number;
  requiresFollowUp: boolean;
  supplementaryTotals?: SupplementaryTotalsEntity[] | null;
  vehicle: Vehicle;
  version: number;
  wasLost: boolean;
  jobSheetProfileId?: null;
  jobSheetProfileName?: null;
  assessor: Assessor;
  excessDiscountAmount: number;
  isJobCompleted: boolean;
  isJobStarted: boolean;
  jobId: string;
  ImagesList?: ImagesListEntity[];
  attachmentLists?: any[] | null;
  taxRegion: string;
  sourceOfBusiness?: null;
  jobSheetProfileVersion: number;
  partsToBeTakenBy?: null;
  customerRelationship?: null;
  assessmentBookingDate?: null;
  ownerDiscountAmount: number;
  ownerDiscountAppliesTo?: null;
  ownerDiscountPercentage: number;
  clientContributionType: string;
  clientCoveragePercentage?: null;
  invoices?: InvoicesEntity[] | null;
  isPrivateWork: boolean;
  referenceNumber?: null;
  isVehicleCollected: boolean;
  baseTaxCodeId: string;
  hasPartsCheckPurchaseOrders: boolean;
  isUpToDateWithPartsCheck: boolean;
  sequence: number;
  dateFullyInvoiced?: null;
  jobIssuedDate?: null;
  isRework: boolean;
  originalEstimateId: string;
  hasRework: boolean;
  wasTowed: boolean;
  customerSurveyId?: null;
  insurerDiscountAmount: number;
  insurerDiscountAppliesTo?: null;
  insurerDiscountPercentage: number;
  insurerCoverage?: null[] | null;
  workType?: null;
  cancellationReason: string;
  departureNote?: null;
  vehicleId?: null;
  trackables?: any[] | null;
  isReadOnly: boolean;
  archivedImages?: null;
  canRemoveOwnerWork: boolean;
  excessVaried: boolean;
  originalJobId?: null;
  cancelled?: null;
  jobClosed?: null;
  updated: string;
  createdEventDate: string;
  updatedByUserId: string;
  imageId?: null;
  estimateBookings?: null[] | null;
  lastCopiedEventDate: string;
  lastCopiedToCompanyId?: null;
  lastCopiedToCompanyName?: null;
  lastTransferRequestId?: null;
  lastTransferRequestStatus?: null;
  lastTransferRequestStatusMessage?: null;
  transferRequestedEventDate: string;
  transferRequestedToCompanyId?: null;
  transferRequestedToCompanyName?: null;
  sequenceUpdated: string;
  invoiceHistory?: null[] | null;
  authorisedAmountHistory?: AuthorisedAmountHistoryEntity[] | null;
  isTotalLoss?: null;
  jobReopened?: null;
  incidentDate?: null;
  sumInsured?: null;
  workplaceId: string;
  cancelledByUserName?: null;
  projectCode?: null;
  projectId?: null;
  projectName?: null;
  lastCustomerImageUploadRequested?: null;
}
export interface Driver {
  contactDetails: ContactDetails;
  licenceNumber?: null;
  identificationType?: null;
  relationshipToOwner?: null;
  remarks?: null;
}
export interface ContactDetails {
  address?: null;
  businessPhone?: null;
  company?: null;
  displayName?: string | null;
  emailAddress?: string | null;
  fax?: null;
  firstName?: string | null;
  homePhone?: null;
  lastName?: string | null;
  mobilePhone?: string | null;
  title?: null;
  shortName?: null;
  driversLicense?: null;
  nationalId?: null;
  preferredContactMethod?: null;
  notes?: null;
}
export interface ExcessDebtorOrPrimaryDebtor {
  debtorId: string;
  isInsurer: boolean;
  name: string;
  useTradePrice: boolean;
  timeScheduleProvider?: null;
  isSelfAssessed: boolean;
}
export interface JobBooking {
  bookingPurposes?: null[] | null;
  estimateId: string;
  expectedArrival: string;
  expectedEnd: string;
  expectedPickup: string;
  expectedStart: string;
  id: string;
  preferredContactAddress?: null;
  preferredContactMethod: string;
  preferredContactName?: null;
  repairDaysRequired: number;
  requiresConfirmation: boolean;
  rescheduledReason?: null;
  version: number;
  actualEnd?: null;
  actualPickup?: null;
  actualStart?: null;
  arrivalDateLocked: boolean;
  endDateLocked: boolean;
  pickupDateLocked: boolean;
  startDateLocked: boolean;
  actualArrival?: null;
  arrivalOdometerDistance: ArrivalOdometerDistanceOrDepartureOdometerDistanceOrOdometerDistance;
  departureOdometerDistance: ArrivalOdometerDistanceOrDepartureOdometerDistanceOrOdometerDistance;
  originalExpectedEnd: string;
}
export interface ArrivalOdometerDistanceOrDepartureOdometerDistanceOrOdometerDistance {
  units: string;
  value: number;
}
export interface NotesEntity {
  body: string;
  created: string;
  noteId: string;
  createdByUserId: string;
  noteType?: string | null;
  resolution?: null;
  includedInEstimatePrintout: boolean;
  createdByUser: string;
  isArchived: boolean;
  isImportant: boolean;
  userImageId?: string;
  userName?: string;
  phoneNumber?: string;
  email?: string;
  isAdmin?: boolean;
  isAdded?: boolean;
  bodyMessage?: string;
  user?: IUser
}
export interface Owner {
  contactDetails: ContactDetails;
  licenceNumber?: null;
  identificationType?: null;
}
export interface SupplementaryTotalsEntity {
  postingAmounts?: PostingAmountsEntityOrAuthorisedTotalsEntity[] | null;
  authorisedTotals?: PostingAmountsEntityOrAuthorisedTotalsEntity[] | null;
  detailId: string;
  detailVersion: number;
  supplementaryId: string;
  supplementaryNumber: number;
  invoiceId?: null;
  invoiceNumber?: null;
  otherTotal: number;
  total: number;
  partsTotal: number;
  labourTotal: number;
}
export interface PostingAmountsEntityOrAuthorisedTotalsEntity {
  itemClass?: null;
  totalAmountIncludingMarkup: number;
  totalMarkup: number;
  linkedAccountId?: null;
  invoiceSubCategory: string;
}
export interface Vehicle {
  body: string;
  colour: string;
  crashbookId: string;
  cylinders: string;
  engineNumber: string;
  make: string;
  manufacturedMonth: number;
  manufacturedYear: number;
  model: string;
  odometer: number;
  odometerDistance: ArrivalOdometerDistanceOrDepartureOdometerDistanceOrOdometerDistance;
  paintCode: string;
  registration: string;
  series: string;
  transmission: string;
  trimCode: string;
  variant: string;
  vin: string;
  countryOfManufacture?: null;
  tyreBrand?: null;
  engineCapacity?: null;
  fuelType?: null;
  featureCodes?: null[] | null;
  description: string;
}
export interface Assessor {
  id: string;
  contactDetails: ContactDetails2;
  name: string;
}
export interface ContactDetails2 {
  address?: null;
  businessPhone?: null;
  company: string;
  displayName: string;
  emailAddress: string;
  fax: string;
  firstName: string;
  homePhone: string;
  lastName?: null;
  mobilePhone: string;
  title?: null;
  shortName?: null;
  driversLicense?: null;
  nationalId?: null;
  preferredContactMethod?: null;
  notes?: null;
}
export interface ImagesListEntity {
  id: string;
  images: ImagesEntity[];
  archivedImages?: ArchivedImagesEntity[] | null;
  defaultImageId?: null;
  isCreated: boolean;
  sequence: number;
  relatedAggregateId: string;
  relatedAggregateType: string;
  categories?: string[] | null;
  relatedAggregateName?: null;
}
export interface ImagesEntity {
  id: string;
  category: string;
  description?: null;
  created: string;
  index: number;
  isArchived: boolean;
  isDefault: boolean;
  full: FullOrThumbnail;
  thumbnail: FullOrThumbnail;
}
export interface FullOrThumbnail {
  attachmentId: string;
  contentType: string;
  id: string;
  length: number;
  pixelHeight: number;
  pixelWidth: number;
  storagePath: string;
  imageId: string;
  variantName: string;
  version: number;
  pixelsPerInch: number;
}
export interface ArchivedImagesEntity {
  id: string;
  category?: string | null;
  description?: null;
  created: string;
  index: number;
  isArchived: boolean;
  isDefault: boolean;
  full?: null;
  thumbnail?: null;
}
export interface InvoicesEntity {
  debtorId: string;
  debtorName: string;
  includesExcess: boolean;
  id?: null;
  invoiceNumber?: null;
  lines?: LinesEntity[] | null;
  status: string;
  supplementaries?: SupplementariesEntity[] | null;
  totalExcludingTax: number;
  totalIncludingTax: number;
  debtorKind: string;
  includesContribution: boolean;
  transactionDate: string;
  jobNumber: number;
  estimateId?: null;
  invoiceOwnerInsteadOfDebtor: boolean;
  hasPayments: boolean;
  isFullyPaid: boolean;
  isFactored: boolean;
  make?: null;
  estimatorId: string;
  estimatorName: string;
  excessVaried: boolean;
  raisedTimestamp?: null;
  voidedTimestamp?: null;
  voidedDate?: null;
  isPrimaryDebtor: boolean;
}
export interface LinesEntity {
  amount: number;
  category: string;
  id: string;
  memo: string;
  subCategory: string;
  taxAmount: number;
  taxCodeId: string;
  linkedToAccountId?: null;
}
export interface SupplementariesEntity {
  aggregateRootId: string;
  authenticatedUserId: string;
  authenticatedUserName: string;
  eventDate: string;
  eventId: string;
  version: number;
  authorisedTotals?: PostingAmountsEntityOrAuthorisedTotalsEntity[] | null;
  detailId: string;
  detailVersion: number;
  supplementaryId: string;
  supplementaryNumber: number;
  isPreAuthorisedTotal: boolean;
}
export interface AuthorisedAmountHistoryEntity {
  amount: number;
  detailId: string;
  modified: string;
  supplementaryId: string;
  supplementaryNumber: number;
}
export interface PrimaryDetail {
  canAuthorise: boolean;
  canCancelAuthority: boolean;
  canRequestAuthority: boolean;
  canCancelAuthorityRequest: boolean;
  canRecalculateAllowances: boolean;
  assessmentStatus: string;
  authorisationOutcome: string;
  bodyType?: null;
  hasSupplementariesToBeAuthorised: boolean;
  isLastAuthorityCancellable: boolean;
  isLastAuthorityRequestCancellable: boolean;
  hasSupplementaryThatCanRequestAuthority: boolean;
  currentSupplementaryNumber: number;
  estimatingProfile: EstimatingProfile;
  generalAllowances?: null[] | null;
  id: string;
  isAwaitingAuthorisationRequest: boolean;
  isLegacy: boolean;
  isMainDetail: boolean;
  labour?: LabourEntity[] | null;
  labourAllowances?: null[] | null;
  lastAuthorisedSupplementaryNumber: number;
  other?: LabourEntity[] | null;
  owningAggregateId: string;
  parts?: LabourEntity[] | null;
  selectedGroupCodes?: null[] | null;
  timeSchedule?: null;
  timeScheduleProviderId?: null;
  towingItemId?: null;
  version: number;
  supplementaryState?: SupplementaryStateEntity[] | null;
  debtorId: string;
  debtorName: string;
  debtorAssessingProvider: string;
  externalId?: null;
  sequence: number;
  isCancelled: boolean;
  assessingProviderId?: null;
  isPreparedForBatching: boolean;
  isCandidateForBatching: boolean;
  isDebtorSelfAssessed: boolean;
  isOutOfScope: boolean;
  quotationRequestId?: null;
  isJobClosed: boolean;
  isReadOnly: boolean;
  wasSentAsPartOfAnOrmBatch: boolean;
  created: string;
  firstAssessed: string;
  firstAuthorityRequested: string;
  startedToBeWritten: string;
  updated: string;
}
export interface LabourEntity {
  isAssessorAdded: boolean;
  comment?: null;
  createdInSupplementaryNumber: number;
  description: string;
  groupCode?: null;
  itemCode: string;
  itemId: string;
  version: number;
  authorisedValues?:
  | AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue[]
  | null;
  currentValue: AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue;
  hasCeramicClearLayer: boolean;
  isASecondColour: boolean;
  isJobSheetHidden: boolean;
  isOutsourced: boolean;
  isTotalDerivedFromHours: boolean;
  labourKind: string;
  modifier: string;
  quotedValues?:
  | AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue[]
  | null;
  supplementaryStatus?: null;
  addedEventDate: string;
  linkedAccountId?: null;
  productId?: null;
  linkedAccountName?: null;
  presentAsItemClass: string;
  custom?: null;
  isOutOfScope?: null;
  removedByUserName?: null;
  updated: string;
}
export interface EstimatingProfile {
  mechanicalHourlyRate: number;
  paintHourlyRate: number;
  removeAndRefitHourlyRate: number;
  repairHourlyRate: number;
}
export interface PartsEntity {
  isAssessorAdded: boolean;
  comment?: null;
  createdInSupplementaryNumber: number;
  description: string;
  groupCode?: string | null;
  itemCode: string;
  itemId: string;
  version: number;
  atInvoice: boolean;
  authorisedValues?:
  | AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue[]
  | null;
  crashbookPartId?: null;
  currentValue: AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue;
  manufacturerListAmount: number;
  partComments?: null;
  partNumber: string;
  partType?: null;
  quotedValues?:
  | AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue[]
  | null;
  supplierName?: null;
  unitCostAmount: number;
  supplementaryStatus?: null;
  addedEventDate: string;
  linkedAccountId?: null;
  productId?: null;
  presentAsItemClass: string;
  linkedAccountName?: null;
  sourceItemClass: string;
  custom?: null;
  isOutOfScope?: null;
  removedByUserName?: null;
  updated: string;
}
export interface AuthorisedValuesEntityOrQuotedValuesEntityOrCurrentValue {
  effectiveTotalAmountIncludingMarkup: number;
  isRemoved: boolean;
  supplementaryNumber: number;
  totalAmountIncludingMarkup: number;
  markupRate: number;
  markupUnitAmount: number;
  quantity: number;
  supply: string;
  unitAmount: number;
  reportOn: boolean;
  isDirectBilled: boolean;
}
export interface SupplementaryStateEntity {
  assessmentStatus: string;
  authorityRequested: boolean;
  authorisationOutcome: string;
  supplementaryNumber: number;
  invoiceId?: null;
  invoiceStatus: string;
  id: string;
}
export interface Totals {
  authorisedTotalLabourAmount: number;
  authorisedTotalLabourHours: number;
  authorisedTotalNonLabourAmount: number;
  authorisedTotalOtherAmount: number;
  authorisedTotalPartsAmount: number;
  clientContributionAmount: number;
  estimatedTotalLabourAmount: number;
  estimatedTotalLabourHours: number;
  estimatedTotalNonLabourAmount: number;
  estimatedTotalOtherAmount: number;
  estimatedTotalPartsAmount: number;
  excessAmount: number;
  excessAuthorisedTotals: ExcessAuthorisedTotalsOrExcessEstimatedTotalsOrExcessOriginalQuotedTotals;
  excessDiscountAmount: number;
  excessEstimatedTotals: ExcessAuthorisedTotalsOrExcessEstimatedTotalsOrExcessOriginalQuotedTotals;
  excessPartsStatus: ExcessPartsStatusOrPrimaryPartsStatus;
  id: string;
  includeOwnerDetailsInJobSheet: boolean;
  ownerDiscountAmount: number;
  ownerDiscountAppliesTo?: null;
  ownerDiscountPercentage: number;
  primaryAuthorisedTotals: PrimaryAuthorisedTotalsOrPrimaryEstimatedTotalsOrPrimaryOriginalQuotedTotals;
  primaryEstimatedTotals: PrimaryAuthorisedTotalsOrPrimaryEstimatedTotalsOrPrimaryOriginalQuotedTotals;
  primaryPartsStatus: ExcessPartsStatusOrPrimaryPartsStatus;
  taxRegion: string;
  totalOwnerPayable: number;
  totalOwnerPayableExcludingOwnerWork: number;
  totalOwnerPayableLabel: string;
  totalDebtorPayable: number;
  totalUnauthorisedIncludingTax: number;
  grandTotalExcludingTax: number;
  grandTotalIncludingTax: number;
  totalOwnerOutstanding: number;
  sequence: number;
  insurerDiscountAmount: number;
  insurerDiscountAppliesTo?: null;
  insurerDiscountPercentage: number;
  totalInsurerPayableLabel: string;
  totalLabourUnauthorised: number;
  excessOriginalQuotedTotals: ExcessAuthorisedTotalsOrExcessEstimatedTotalsOrExcessOriginalQuotedTotals;
  primaryOriginalQuotedTotals: PrimaryAuthorisedTotalsOrPrimaryEstimatedTotalsOrPrimaryOriginalQuotedTotals;
  sequenceUpdated: string;
}
export interface ExcessAuthorisedTotalsOrExcessEstimatedTotalsOrExcessOriginalQuotedTotals {
  displayExTaxTotal: boolean;
  itemClassTotals?: null[] | null;
  labourPercentage: number;
  nonLabourPercentage: number;
  totalExcludingTaxes: number;
  totalHours: number;
  totalIncludingMarkup: number;
  totalIncludingTaxes: number;
  totalLabourAmount: number;
  totalNonLabourAmount: number;
  totalOtherAmount: number;
  totalPartsAmount: number;
  totalsLines?: null[] | null;
}
export interface ExcessPartsStatusOrPrimaryPartsStatus {
  lastPriceStatus?: null;
  pricesAvailable: number;
  pricesFailed: number;
  pricesRequested: number;
  schemaRevision: number;
  sequence: number;
}
export interface PrimaryAuthorisedTotalsOrPrimaryEstimatedTotalsOrPrimaryOriginalQuotedTotals {
  displayExTaxTotal: boolean;
  itemClassTotals?: ItemClassTotalsEntity[] | null;
  labourPercentage: number;
  nonLabourPercentage: number;
  totalExcludingTaxes: number;
  totalHours: number;
  totalIncludingMarkup: number;
  totalIncludingTaxes: number;
  totalLabourAmount: number;
  totalNonLabourAmount: number;
  totalOtherAmount: number;
  totalPartsAmount: number;
  totalsLines?: TotalsLinesEntity[] | null;
}
export interface ItemClassTotalsEntity {
  amount: number;
  hours: number;
  itemClass: string;
  percentage: number;
}
export interface TotalsLinesEntity {
  amount: number;
  description: string;
}
export interface DebtorProfile {
  id: string;
  version: number;
  allowanceProfileId: string;
  blendRate: number;
  hoursUnitPluralLabel: string;
  hoursUnitSingularLabel: string;
  isLegacyEstimatingProfile: boolean;
  labourInputModes: LabourInputModes;
  labourRates: LabourRates;
  name: string;
  printOptions: PrintOptions;
  estimatingStyle: string;
  allowanceProfileName?: null;
  allowZeroDollarPartPrices: boolean;
  defaultRepairToPdr: boolean;
  isArchived: boolean;
  sequence: number;
  defaultProductCatalogId: string;
  defaultProductCatalogName: string;
  sequenceUpdated: string;
}
export interface LabourInputModes {
  mechanicalLabourInputMode: string;
  paintLabourInputMode: string;
  removeAndRefitLabourInputMode: string;
  repairLabourInputMode: string;
}
export interface LabourRates {
  removeRefitLabourRate: number;
  repairLabourRate: number;
  mechanicalLabourRate: number;
  paintLabourRates?: PaintLabourRatesEntity[] | null;
}

export interface PrintOptions {
  detailFormatId: string;
  itemiseAllParts: boolean;
  labourStyleId: string;
  showListPrice: boolean;
  showMarkupSeparately: boolean;
  showPartNumbers: boolean;
  startANewPage: boolean;
  summaryFormatId: string;
  supplementariesItemise: boolean;
  supplementariesStartANewPage: boolean;
}
export interface IUser {
  aggregateRootId: string;
  weeklyOrdinaryHours: number;
  id: string;
  version: number;
  contactDetails: ContactDetails;
  hasPassword: boolean;
  imageId?: string;
  isToolShopUser: boolean;
  language: string;
  lunchDuration: string;
  name: string;
  roles: string[];
  status: string;
  team?: string;
  workHours: WorkHour[];
  lunchStartTime: string;
  rosterId?: string;
  isEstimator: boolean;
  maximumDiscountPercentage: number;
  hasTwoFactor: boolean;
  efficiency: number;
  productivity: number;
  activityGroupId?: string;
  activityGroupName?: string;
  isWorkshopUser: boolean;
  isAttendanceUser: boolean;
  multipleClockOnRule: string;
  proRata: number;
  proRataStartDate?: string;
  jobActivityCapabilities: JobActivityCapability[];
  activeFrom: string;
  activeTo: any;
  sequence: number;
  agreedTargetForEfficiency: number;
  overtime1MinimumThreshold: any;
  overtime2MinimumThreshold: any;
  isShadowUser: boolean;
  jobTitle: any;
  trustRelationships: any[];
  paidBreakAllowance: string;
  workplaceId: string;
  sequenceUpdated: string;
  created: string;
  createdByUserId: string;
  createdByUserName: string;
  passwordLastChanged: string;
  passwordLastChangedByUserId: string;
  passwordLastChangedByUserName: string;
}

export interface WorkHour {
  dayOfWeek: string;
  finishTime?: string;
  includesLunch: boolean;
  startTime?: string;
  includesOvertime: boolean;
}

export interface JobActivityCapability {
  capabilityLevel: string;
  id: string;
}

export interface progess {
  image: any;
  status: string | null;
  detail: string | null;
  video: string;
  isZero: boolean;
  percent: number;
  label: string;
}

export interface StampedCustomer {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  customerEmail: string;
  externalId?: any;
  uuid: string;
  profileImageUrl?: any;
  notes?: any;
  tags: string;
  country?: any;
  ipAddress?: any;
  ipAddressSource?: any;
  isSubscribed: boolean;
  sentimentScore?: any;
  sentiment?: any;
  points: number;
  totalSpent?: any;
  isConfirmed?: any;
  vipTierId?: any;
  dateCreated: Date;
  dateUpdated?: any;
  dateTierUpdated: Date;
  dateTierEligibilityCheck: Date;
  dateTierEligibilityUntil?: any;
  dateLastLogin?: any;
  dateLastActivityRewards?: any;
  dateBirthday: Date;
  shopId: number;
  vipTier?: any;
  referralCode: string;
  referralUrl: string;
}

export interface StampedResult {
  customer: StampedCustomer;
  countReviews: number;
  countReferrals: number;
  points: number;
  referralUrl: string;
}

export interface Debugging {
  type: string;
  time: number;
}

export interface ISearchCustomerResp {
  results: StampedResult[];
  total: number;
  page: number;
  totalPages: number;
  debugging: Debugging[];
}
export interface Points {
  points: number;
  points_current_with_name: string;
}

export interface Earning {
  campaignEvent: number;
  isCompleted: boolean;
  totalCount: number;
  campaignEventString: string;
  pointsFullName: string;
  id: number;
  title: string;
  titlePublic: string;
  description: string;
  urlImage: string;
  points: number;
  limitNumberPerCustomer: number;
  isSystem: boolean;
  isActive: boolean;
  isEnabledNotifications: boolean;
  isEnabledLimits: boolean;
  dateCreated: Date;
  campaignRulesList: any[];
  isEnabledRules?: boolean;
}

export interface Spending {
  entitledCollectionIds: string;
  campaignType: number;
  isRedeemable: boolean;
  totalCount: number;
  campaignTypeString: string;
  pointsFullName: string;
  id: number;
  title: string;
  titlePublic: string;
  description: string;
  urlImage: string;
  points: number;
  limitNumberPerCustomer: number;
  isSystem: boolean;
  isActive: boolean;
  isEnabledNotifications: boolean;
  isEnabledLimits: boolean;
  dateCreated: Date;
  campaignRulesList: any[];
}

export interface Friend {
  id: number;
  title: string;
  titlePublic: string;
  titleActivity?: any;
  description?: any;
  urlImage?: any;
  urlNotification?: any;
  intervalDelay?: any;
  codePrefix?: any;
  discountValue: number;
  allocationMethod?: any;
  limitAmountMinimum?: any;
  limitDurationDays?: any;
  entitledCollectionIds: string;
  entitledProductIds?: any;
  entitledVariantIds?: any;
  campaignType: number;
  rewardType: number;
  isDeleted?: any;
  shopId: number;
  dateCreated: Date;
  campaignTypeString: string;
  rewardTypeString: string;
}

export interface Advocate {
  id: number;
  title: string;
  titlePublic: string;
  titleActivity?: any;
  description?: any;
  urlImage?: any;
  urlNotification?: any;
  intervalDelay?: any;
  codePrefix?: any;
  discountValue: number;
  allocationMethod?: any;
  limitAmountMinimum?: any;
  limitDurationDays?: any;
  entitledCollectionIds: string;
  entitledProductIds?: any;
  entitledVariantIds?: any;
  campaignType: number;
  rewardType: number;
  isDeleted?: any;
  shopId: number;
  dateCreated: Date;
  campaignTypeString: string;
  rewardTypeString: string;
}

export interface Referrals {
  friend: Friend;
  advocate: Advocate;
  refer_title: string;
  refer_description: string;
}

export interface ListReward {
  id: number;
  title: string;
  titlePublic: string;
  titleActivity?: any;
  description?: any;
  urlImage?: any;
  urlNotification?: any;
  codePrefix?: any;
  discountValue?: any;
  allocationMethod?: any;
  limitAmountMinimum?: any;
  limitDurationDays?: any;
  entitledCollectionIds: string;
  entitledProductIds?: any;
  entitledVariantIds?: any;
  rewardType: number;
  isDeleted?: any;
  vipTierId: number;
  dateCreated: Date;
  rewardTypeString: string;
}

export interface VipTier {
  id: number;
  title: string;
  description?: any;
  goalValue: number;
  urlImage: string;
  listBenefits: any[];
  listRewards: ListReward[];
  dateCreated: Date;
}

export interface Campaigns {
  earnings: Earning[];
  spendings: Spending[];
  coupons: any[];
  referrals: Referrals;
  vip_tiers: VipTier[];
}

export interface Links {
  shop: string;
  signup: string;
  login: string;
  facebook: string;
  twitter?: any;
  instagram: string;
  pinterest?: any;
  youtube: string;
  tiktok: string;
}

export interface Card {
  key: string;
  html: string;
  type: string;
  title?: any;
}

export interface View {
  key: string;
  html: string;
  type?: any;
  title: string;
}

export interface Html {
  main: string;
  cards: Card[];
  views: View[];
}

export interface ICustomerRewardDataResp {
  customer: any;
  points: Points;
  campaigns: Campaigns;
  links: Links;
  html: Html;
  referrer: any;
  branding: boolean;
  d: any[];
}
export interface myReferals {
  name: string;
  email: string;
  status: string;
  points: number;
}

export interface redeemProduct {
  refNo: string;
  sumInsured: number;
  displayAsField: string;
  total: string;
  contactNotes: string;
  estimateId: string;
  primaryDetailsId: string;
}

export interface ISearchedEstimate {
  isTotalLoss: boolean;
  jobsToBeInvoicedGroup?: any;
  arrived?: Date;
  assessingProviderId?: any;
  awaitingAuthorisation: boolean;
  bookingId?: any;
  created: string;
  estimateDueDate?: any;
  estimateNumber: number;
  excessDetailAssessmentStatus?: any;
  excessDetailAuthorisationOutcome?: any;
  expectedArrival?: Date;
  expectedPickup?: Date;
  imageId?: any;
  includeOwnerWork: boolean;
  insurerName: string;
  inWorkshop: boolean;
  isCancelled: boolean;
  isClosed: boolean;
  isHeaderLegacy: boolean;
  isPrimaryDetailLegacy: boolean;
  isPrivateWork: boolean;
  isSecondaryDetailLegacy: boolean;
  isVehicleOnSite: boolean;
  isWritten: boolean;
  jobNumber: number;
  ownerDisplayName: string;
  ownerMobilePhone: string;
  primaryDetailAssessmentStatus: string;
  primaryDetailAuthorisationOutcome: string;
  requestDate: string;
  requiresAssessmentBooking: boolean;
  requiresAuthorisation: boolean;
  requiresEstimateBooking: boolean;
  requiresFollowUp: boolean;
  requiresInvoicing: boolean;
  requiresRepairBooking: boolean;
  totalAmount: number;
  totalAuthorisedAmount: number;
  totalInvoicedAmount: number;
  vehicleBody?: any;
  vehicleColour?: any;
  vehicleMake?: any;
  vehicleModel?: any;
  vehicleRegistration: string;
  vehicleSeries?: any;
  primaryDetailId: string;
  awaitingAssessmentAuthorityGroupCodes: string[];
  excessDetailId?: any;
  actualCompleted?: any;
  jobIsComplete: boolean;
  actualPickup?: any;
  unauthorizedSupplementaryCount: number;
  assessmentBookingDate?: any;
  excessDetailInfoAvailable: boolean;
  primaryDetailInfoAvailable: boolean;
  id: string;
  fullyInvoiced: boolean;
  hasAuthorisedSupp: boolean;
  jobId: string;
  headerInfoAvailable: boolean;
  expectedStart?: Date;
  bookingGroupCodes: string[];
  isVehicleCollected: boolean;
  estimateVersion: number;
  excessDetailVersion: number;
  primaryDetailVersion: number;
  sequence: any;
  primaryDebtorId: string;
  isRework: boolean;
  originalEstimateId: string;
  wasLost: boolean;
  ownerLastName: string;
  isOwnerWorkEmpty: boolean;
  workType?: any;
  estimatorName: string;
  vehicleId?: any;
  isCandidateForOrmBatching: boolean;
  estimatorId: string;
  actualStarted?: any;
  excessDetailLastUpdated?: any;
  headerLastUpdated: Date;
  primaryDetailLastUpdated: Date;
  isOutOfScope: boolean;
  isPrimaryDebtorSelfAssessed: boolean;
  jobAuthorityGroup?: any;
  sequenceUpdated: Date;
  isExcessDetailHasSupplementariesToBeAuthorised: boolean;
  isPrimaryDetailHasSupplementariesToBeAuthorised: boolean;
  dateFullyInvoiced?: any;
  cancelled: Date;
  location?: any;
  workplaceId: string;
  expectedCompletion?: Date;
  projectCode?: any;
  projectId?: any;
  projectName?: any;
}

export interface BookingInspectionProps {
  estimateDetails: JobEstimationDetail;
  updateEstimateDetails: Function;
  handleDashboardSelectedTab: (dashboardTab: string) => void;
}

export interface ISearchEstimateResp {
  items: ISearchedEstimate[];
}
export interface Debtor {
  id: string;
  version: number;
  code?: string | null;
  imageId: string;
  isInsurer: boolean;
  name: string;
  profiles?: ProfilesEntity[] | null;
  debtorId: string;
  fixedDiscountPercentage?: number | null;
  maximumDiscountPercentage?: number | null;
  isReadOnly: boolean;
  isArchived: boolean;
  printCustomerSignatureArea: boolean;
  printServiceAdvisorSignatureArea: boolean;
  canBeRenamed: boolean;
  taxRegistrationNumber?: string | null;
  invoiceLayoutPreference?: string | null;
  invoiceExcessLayoutPreference?: string | null;
  mechanicalPrintMode?: string | null;
  paintPrintMode?: string | null;
  removeAndRefitPrintMode?: string | null;
  repairPrintMode?: string | null;
  arnieEmailAddress?: string | null;
  arnieRepairerId?: string | null;
  assessingProvider?: string | null;
  arnieBrandCode?: string | null;
  paymentTermsPreference: string;
  markupRates: MarkupRates;
  useTradePrice: boolean;
  timeScheduleProvider?: string | null;
  printPartsMarkupAsSubtotal: boolean;
  printSubletMarkupAsSubtotal: boolean;
  ownerToBeInvoicedInsteadOfDebtor: boolean;
  isSelfAssessed: boolean;
  partsTraderInsurerCode?: null;
  isDefault: boolean;
  miscellaneousPrintMode?: string | null;
  partsPrintMode?: string | null;
  subletPrintMode?: string | null;
  sequence: number;
  partsTraderFreightImportOption?: null;
  printEstimateComments: boolean;
  printReportOnItems: boolean;
  isMarkupRatesOverridden: boolean;
  isSelfAssessedOverridden: boolean;
  isProfileOverridden: boolean;
  printStatementByDefault: boolean;
  printStartCompletionDates: boolean;
  isTaxExemptByDefault: boolean;
  sequenceUpdated: string;
}
export interface ProfilesEntity {
  estimatingProfileId: string;
  estimatingProfileName?: string | null;
  // labourRates: LabourRates;
  labourRatesOverridden: boolean;
}

export interface MarkupRates {
  aftermarketRate: number;
  exchangedRate: number;
  netNewRate: number;
  newRate: number;
  nonGenuineRate: number;
  usedRate: number;
  subletRate: number;
}

export interface EstimatingProfile {
  id: string;
  version: number;
  allowanceProfileId: string;
  blendRate: number;
  hoursUnitPluralLabel?: string | null;
  hoursUnitSingularLabel?: string | null;
  isLegacyEstimatingProfile: boolean;
  labourInputModes: LabourInputModes;
  labourRates: LabourRates;
  name: string;
  printOptions: PrintOptions;
  estimatingStyle: string;
  allowanceProfileName?: null;
  allowZeroDollarPartPrices: boolean;
  defaultRepairToPdr: boolean;
  isArchived: boolean;
  sequence: number;
  defaultProductCatalogId: string;
  defaultProductCatalogName: string;
  sequenceUpdated: string;
}
export interface PaintLabourRatesEntity {
  id: string;
  label: string;
  rate: number;
}

export interface EmailTemplate {
  id: string;
  isIncomplete: boolean;
  message: string;
  name: string;
}

export enum IQuestionType {
  FAULT = "FAULT",
  FAULT_DETAILS = "FAULT_DETAILS",
  FAULT_INSURANCE = "FAULT_INSURANCE",
}

export interface IQuestionResponse {
  key: string;
  value: string;
  type: IQuestionType;
  actionState: IButtonState;
  state: number;
}

export interface IAvailableQuestions {
  state: number;
  step: number;
  type: IQuestionType;
  title: string;
  actionState: IButtonState;
}

export interface SelectionItem {
  id: number;
  value: string;
  state: boolean;
}

export enum AssessmentType {
  Minor = "Minor",
  Moderate = "Moderate",
  Major = "Major",
}

export const workTypeObject: { [key in AssessmentType]: string } = {
  [AssessmentType.Minor]: WorkType.SMALL,
  [AssessmentType.Moderate]: WorkType.MEDIUM,
  [AssessmentType.Major]: WorkType.LARGE,
};

export enum IButtonState {
  YES = "YES",
  NO = "NO",
  NONE = "NONE",
}

export interface AppointmentSlot {
  time: string;
  // id: string | null | undefined;
  occupiedDropOff: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  index?: number;
}
export interface bookingCalendarProps {
  estimateDetails: JobEstimationDetail;
  ibsService: IBodyshopService;
  availableAppointments: any;
  selectedDate?: Moment | null | string;
  onDateSelected: (date: any) => void;
  bookingAllowance: BookingAllowance;
  customQADetails: IQACustomDetails | null;
  slots?: AppointmentSlot[];
  onSlotPicked?: (date: any) => void;
  isSelected?: any;
  handleConfirm?: (date: any) => void;
  showLoader?: boolean;
  commentBox?: JSX.Element;
  isButtonDisabledForNonStateChanged?: boolean
}
export interface bookingCalendarState {
  customQADetails: IQACustomDetails | null;
  dropoffSelectedDate: any;
  pickupSelectedDate: any;
  showBookingSuccessMessage: boolean;
  showHireCarDialog: boolean;
  showUberDialog: boolean;
  isBookingRequested: boolean;
  selectedDate?: any;
  bookingAllowance: BookingAllowance;
  workingDays: number;
  selectedTabIndex: number;
}

export enum AdminChecklistItems {
  BOOKING_FLOW = "Booking Flow",
  ONBOARDING_FLOW = "Onboarding Flow",
}

export interface DatepickerProps {
  dropoffSelectedDate: any;
  selectedDate: any;
  showLoader?: boolean;
  availableAppointments: Array<{ dueDate?: any, showLoader?: boolean }>; // Make dueDate optional
  onDateSelected: (date: any) => void;
}

export interface BookingProps {
  estimateDetails: JobEstimationDetail;
  updateEstimateDetails: Function;
  handleDashboardSelectedTab: (dashboardTab: string) => void;
  handleBookingCompleted: (isCompleted: boolean) => void;
  isBookingDetailCompleted: boolean;
}

export interface IbsResponse {
  IsSuccess: boolean;
  CustomData: any | null;
  Data: any;
  Message: string;
}

export interface Feedback {
  // Required fields
  EstimateId: string;
  Rating?: number;
  IsRecommentUS?: boolean;
  BestDescribe?: string;
  HighlightofExpeciance?: string;
  ImproveOn?: string;
  Remark?: string;
  JobNumber?: string;
}

interface Resource {
  amount: number;
  resource: {
    groupId: string;
    groupName: string;
    name: string;
    resourceId: string;
    workplaceId: string;
  };
  units: number;
}

interface OdometerDistance {
  units: string;
  value: number;
}

interface Trackable {
  id: string;
  name: string;
  status: string;
}

export interface EstimatePlanningJob {
  isOnHold: boolean;
  arrival: string;
  bookingId: string;
  estimateId: string;
  isAuthorised: boolean;
  jobId: string;
  jobStatus: string;
  pickup: string;
  repairDaysRequired: number;
  repairEnd: string;
  repairStart: string;
  resources: Resource[];
  suggestedRepairDaysRequired: number;
  excessDetailId: string | null;
  hasHeader: boolean;
  isCancelled: boolean;
  jobSheetProfileId: string | null;
  jobSheetProfileVersion: number;
  primaryDetailId: string;
  debtorName: string;
  displayName: string;
  estimateNumber: number;
  mobilePhone: string;
  vehicleRegistration: string | null;
  vehicleDescription: string;
  vehicleColour: string;
  arrivalOdometerDistance: OdometerDistance;
  excessUseTradePrice: boolean;
  primaryUseTradePrice: boolean;
  neededOrderedArrived: string | null;
  isAuthorityRequested: boolean;
  isInvoiced: boolean;
  workType: string;
  vehicleId: string;
  totalValueIncludingTax: number;
  workplaceId: string;
  vehicleLocation: string | null;
  loanCarBookingId: string | null;
  loanCarBookingDateFrom: string | null;
  loanCarBookingDateTo: string | null;
  loanCarBookingStatus: string | null;
  trackables: Trackable[];
  earliestStart: string;
  latestEnd: string;
  isRework: boolean;
  jobHeldHistory: any[];
  onHoldUntil: string | null;
  loanCarClassificationRequested: string | null;
  loanCarRequested: boolean;
}

export const WorkTypeValues = [WorkType.SMALL, WorkType.MEDIUM, WorkType.LARGE];

interface TimeSlot {
  dayOfWeek: string;
  id: string;
  maximum: number;
  minutesDuration: number;
  startTime: string;
  date: string
}

export interface AvailableTimeSlotsObject {
  effectiveFromDate: string;
  id: string;
  sortedTimeSlots: TimeSlot[];
  timeslots: TimeSlot[];
}

export interface GeneralSettingType {
  value: boolean;
  name?: string;
}